const getlanguagePrefix = function (currentLang) {
  return currentLang === 'ru' ? '' : `/${currentLang}`;
};

export default getlanguagePrefix;
